<template>
  <div class="entertainment ml-1 mr-1">
    <div class="left col-md-8 float-left pl-0 pr-0">
      <slide :login-request="loginRequest"></slide>
      <news :login-request="loginRequest"></news>
      <love :login-request="loginRequest"></love>
      <story :login-request="loginRequest"></story>
    </div>
    <div class="right col-md-4 float-right pr-0 pl-0">
      <music-top class="mt-5"></music-top>
      <div class="mt-5"></div>
      <singer-top></singer-top>
      <div class="ads" v-for="item in adv">
        <a :href="item.link">
          <img :src="item.image"/>
        </a>
      </div>
    </div>
    <div style="clear: both"></div>
    <div>
      <partner></partner>
    </div>

    <modal :modal-title="settings.modalTitle" :modal-message="settings.loginAlert"></modal>
  </div>
</template>

<script>
  import SlideEntertainment from './Slide'
  import MusicTop from '../../home/web/MusicTop'
  import MostSinger from '../../home/web/MostSinger'
  import Partner from '../../home/wap/Partner'
  import News from './News'
  import Love from './Love'
  import Story from './Story'

  export default {
    name: "Entertainment",
    components: {
      'slide': SlideEntertainment,
      'music-top': MusicTop,
      'singer-top': MostSinger,
      'partner': Partner,
      'news': News,
      'love': Love,
      'story': Story
    },
    data () {
      return {
        adv: [],
        loginRequest: null
      }
    },
    methods: {
      getAdv(){
        this.adv = [];
        axios.post(api.adv)
          .then(response => {
            var res = response.data.result;
            res.forEach(item => {
              if(item.page == "entertainment" && item.position == 1){
                this.adv.push(item);
              }
            });
          })
          .catch(e => {

          });
      },
      getParamLogin(){
        axios.post(api.paramLogin, {code: "login"})
          .then(response => {
            var res = response.data.result;
            this.loginRequest = res[0].value;
          })
          .catch(e => {

          });
      }
    },
    watch: {
      "$route.path": {
        handler: function(val){
          this.getAdv();
          this.getParamLogin();
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .right{
    margin-top: -15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/entertainment/wap/Entertainment.vue